import { KeyboardDatePicker } from '@material-ui/pickers';
import moment from 'moment';
import React, { FunctionComponent } from 'react';

import Texto from '@infotrack/presentacion-componentes/texto';

import IDocumentoFiltro from 'Infotrack@Modelos/negocioRefactor/entidades/consulta/documento/IDocumentoFiltro';

interface ICampoFechaEntregaProps {
    manejarCambioFiltro: (
        nombreFiltro: keyof IDocumentoFiltro,
        nuevoValor: IDocumentoFiltro[keyof IDocumentoFiltro]
    ) => any;
    valor?: string;
}

const CampoFechaEntrega: FunctionComponent<ICampoFechaEntregaProps> = ({ manejarCambioFiltro, valor }) => (
    <KeyboardDatePicker
        format="DD/MM/YYYY"
        fullWidth
        inputVariant="outlined"
        label={<Texto id="Documentos.CampoFechaEntrega.Nombre" />}
        onChange={(date) => {
            if (date) manejarCambioFiltro('FechaEntrega', date.format('YYYY-MM-DD'));
        }}
        value={valor ? moment(valor, 'YYYY-MM-DD') : null}
    />
);

export default CampoFechaEntrega;
